import React from 'react';
import { FadeIn } from './FadeIn';
export function RecipesSection() {
  const recipes = [{
    emoji: '🍬',
    name: 'Gomitas de Caldo de Huesos',
    tag: 'Antiinflamatorio',
    color: 'bg-orange-warm/20 text-orange-warm'
  }, {
    emoji: '🥣',
    name: "Sopa 'Escudo Dorado'",
    tag: 'Antiviral',
    color: 'bg-blue-100 text-blue-600'
  }, {
    emoji: '🥤',
    name: 'Smoothie Inmune-Pro',
    tag: 'Probiótico',
    color: 'bg-green-mint/40 text-green-deep'
  }, {
    emoji: '🥩',
    name: 'Nuggets con Zinc',
    tag: 'Defensas',
    color: 'bg-orange-warm/20 text-orange-warm'
  }, {
    emoji: '⚡',
    name: "Shot 'Poción de Dragón'",
    tag: 'Antiviral SOS',
    color: 'bg-red-alert/10 text-red-alert'
  }, {
    emoji: '🌙',
    name: 'Leche Dorada Inmune',
    tag: 'Reparación',
    color: 'bg-blue-100 text-blue-600'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-420">
      <div className="max-w-5xl mx-auto" data-id="element-421">
        <FadeIn data-id="element-422">
          <div className="text-center mb-12" data-id="element-423">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep mb-4" data-id="element-424">
              🍽️ MÓDULO 6 — RECETARIO
            </h2>
            <p className="text-text-main/80 text-lg" data-id="element-425">
              Medicina disfrazada de comida deliciosa
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-426">
          {recipes.map((recipe, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-427">
              <div className="bg-cream p-6 rounded-2xl text-center h-full hover:-translate-y-2 transition-transform duration-300 border border-transparent hover:border-green-mint/50 shadow-sm" data-id="element-428">
                <div className="text-5xl md:text-6xl mb-4" data-id="element-429">{recipe.emoji}</div>
                <h3 className="font-bold text-text-main mb-3 text-sm md:text-base leading-tight" data-id="element-430">
                  {recipe.name}
                </h3>
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${recipe.color}`} data-id="element-431">
                  {recipe.tag}
                </span>
              </div>
            </FadeIn>)}

          <FadeIn delay={0.6} data-id="element-432">
            <div className="bg-green-deep p-6 rounded-2xl text-center h-full flex flex-col items-center justify-center text-white shadow-soft" data-id="element-433">
              <div className="text-4xl mb-2" data-id="element-434">➕</div>
              <h3 className="font-bold text-lg" data-id="element-435">9 recetas más</h3>
              <p className="text-green-mint text-xs mt-2" data-id="element-436">
                Para cubrir cada comida del día
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}